module.exports = __webpack_public_path__ + "sflyssofe.e90984ef5b.svg";